import { UserContext } from '../user-context';

/**
 * Model definition for UserContext
 */
export interface InternUserContext {
  __component: 'intern.user-context';
  id: string;
  contexts: UserContext[];
}

export function isInternUserContext(obj: { __component?: string }): obj is InternUserContext {
  return obj.__component === 'intern.user-context';
}
